import ReactGA from 'react-ga4'

export const GA_MEASUREMENT_ID = 'G-CHFPDBF80C'

let isInitialized = false

export function initAnalytics(): void {
  if (isInitialized) return
  ReactGA.initialize(GA_MEASUREMENT_ID)
  isInitialized = true
}

export function trackPageView(path: string, title?: string): void {
  if (!isInitialized) return
  ReactGA.send({
    hitType: 'pageview',
    page: path,
    title,
  })
}

export function trackEvent(
  action: string,
  params?: Record<string, string | number | boolean>,
): void {
  if (!isInitialized) return
  ReactGA.event(action, params)
}
